import * as React from 'react';
import { NO_ATTACHMENTS } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { StyledGalleryWrapper, StyledNoAttachments } from './GalleryContainer.style';
import { RecursiveAlbumRenderer } from './RecursiveAlbumRenderer';
import { DOWNLOAD_ARTIFACT } from '../constants';
/**
 * GalleryContainer - Renders a gallery of albums with their tiles
 *
 * This component acts as the main container for displaying albums and their contents.
 * It handles empty state display and passes all props to the RecursiveAlbumRenderer.
 */
export const GalleryContainer = (props) => {
    const translateFn = TranslationService.translate;
    return (React.createElement(StyledGalleryWrapper, { id: `${DOWNLOAD_ARTIFACT.ID_GALLERY_TILE_WRAPPER}_${props.id}`, "data-testid": `${DOWNLOAD_ARTIFACT.ID_GALLERY_TILE_WRAPPER}_${props.id}`, style: props.panelBackgroundColor ? { backgroundColor: props.panelBackgroundColor } : undefined, isSelectModeOn: props.isSelectModeOn }, props.albums.length ? (React.createElement(RecursiveAlbumRenderer, Object.assign({}, props))) : (React.createElement(StyledNoAttachments, { "data-testid": DOWNLOAD_ARTIFACT.ID_NO_ATTACHMENT_WRAPPER }, translateFn(NO_ATTACHMENTS)))));
};
GalleryContainer.defaultProps = {
    shouldShowThumbnailForPdf: false // Controls whether PDF thumbnails are displayed
};
//# sourceMappingURL=GalleryContainer.js.map